<template>
  <div>
    <a-card title="库存流水详情">
      <a-button slot="extra" type="primary" ghost @click="() => {this.$store.commit('setEffect', true);  this.$router.go(-1); }"> <a-icon type="left" />返回</a-button>
      <section id="pdfDom">
        <a-spin :spinning="loading">
          <a-descriptions bordered>
            <a-descriptions-item label="创建人">
              {{ info.creator_name }}
            </a-descriptions-item>
            <a-descriptions-item label="创建时间">
              {{ info.create_time }}
            </a-descriptions-item>
            <a-descriptions-item label="客户名">
              {{ info.client_name }}
            </a-descriptions-item>
            <a-descriptions-item label="仓库">
              {{ info.warehouse_name }}
            </a-descriptions-item>
            <a-descriptions-item label="产品名称">
              {{ info.goods_name }}
            </a-descriptions-item>
            <a-descriptions-item label="产品编号">
              {{ info.goods_number }}
            </a-descriptions-item>
            <a-descriptions-item label="单位名称">
              {{ info.user_name }}
            </a-descriptions-item>
            <a-descriptions-item label="流水类型">
              {{ info.type_display }}
            </a-descriptions-item>
            <a-descriptions-item label="变化之前数量">
              {{ info.quantity_before }}
            </a-descriptions-item>
            <a-descriptions-item label="变化数量">
              {{ info.quantity_change }}
            </a-descriptions-item>
            <a-descriptions-item label="变化之后数量">
              {{ info.quantity_after }}
            </a-descriptions-item>
            <a-descriptions-item v-if="info.purchase_order_number" label="采购单号">
              <a @click="clickpurchaseorder">{{ info.purchase_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_purchase_order_number" label="作废采购单号">
              <a @click="clickvoidpurchaseorder">{{ info.void_purchase_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.purchase_return_order_number" label="采购退货单号">
             <a @click="clickpurchasereturnorder">{{ info.purchase_return_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_purchase_return_order_number" label="作废采购退货单号">
              <a @click="clickvoidpurchasereturnorder">{{ info.void_purchase_return_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.sales_order_number" label="销售单号" >
              <a @click="clicksalesorder">{{ info.sales_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_sales_order_number" label="作废销售单号">
              <a @click="clickvoidsalesorder">{{ info.void_sales_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.sales_return_order_number" label="销售退货单号">
              <a @click="clicksalesreturnorder">{{ info.sales_return_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_sales_return_order_number" label="作废销售退货单号">
              <a @click="clickvoidsalesreturnorder">{{ info.void_sales_return_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.stock_in_order_number" label="入库通知单号">
              <a @click="clickstockinorder">{{ info.stock_in_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_stock_in_order_number" label="作废入库通知单号">
              {{ info.void_stock_in_order_number }}
            </a-descriptions-item>
            <a-descriptions-item v-if="info.stock_out_order_number" label="出库通知单号">
            <a @click="clickstockoutorder">{{ info.stock_out_order_number }}</a>
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_stock_out_order_number" label="作废出库通知单号">
              {{ info.void_stock_out_order_number }}
            </a-descriptions-item>
            <a-descriptions-item v-if="info.stock_check_order_number" label="盘点单号">
              {{ info.stock_check_order_number }}
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_stock_check_order_number" label="作废盘点单号">
              {{ info.void_stock_check_order_number }}
            </a-descriptions-item>
            <a-descriptions-item v-if="info.stock_transfer_order_number" label="调拨单号">
              {{ info.stock_transfer_order_number }}
            </a-descriptions-item>
            <a-descriptions-item v-if="info.void_stock_transfer_order_number" label="作废调拨单号">
              {{ info.void_stock_transfer_order_number }}
            </a-descriptions-item>
          </a-descriptions>
        </a-spin>
      </section>
    </a-card>
  </div>
</template>

<script>
  import { inventoryFlowsDetail } from '@/api/warehouse'
  
  export default {
    data() {
      return {
        loading: false,
        info: {},
      }
    },
    created(){
      this.initData();
    },
    methods: {
      initData() {
        this.info = JSON.parse(this.$route.query.item);
        // this.loading = true;
        // inventoryFlowsDetail({ id: this.$route.query.id }).then(data => {
        //   this.info = data;
        // }).finally(() => {
        //   this.loading = false;
        // });
      },

      clicksalesorder() {
        this.$router.push({ path: '/sale/sale_record_detail', query: { id: this.info.sales_order } });
      },
      clickpurchaseorder() {
        this.$router.push({ path: '/purchasing/purchase_record_detail', query: { id: this.info.purchase_order } });
      },
      clickvoidpurchaseorder() {
        this.$router.push({ path: '/purchasing/purchase_record_detail', query: { id: this.info.void_purchase_order } });
      },
      clickpurchasereturnorder() {
        this.$router.push({ path: '/purchasing/return_record_detail', query: { id: this.info.purchase_return_order } });
      },
      clickvoidpurchasereturnorder() {
        this.$router.push({ path: '/purchasing/return_record_detail', query: { id: this.info.void_purchase_return_order } });
      },
      clickvoidsalesorder() {
        this.$router.push({ path: '/sale/sale_record_detail', query: { id: this.info.void_sales_order } });
      },
      clicksalesreturnorder() {
        this.$router.push({ path: '/sale/sale_return_detail', query: { id: this.info.sales_return_order } });
      },
      clickvoidsalesreturnorder() {
        this.$router.push({ path: '/sale/sale_return_detail', query: { id: this.info.void_sales_return_order } });
      },
      clickstockinorder() {
        this.$router.push({ path: '/warehouse/inStock_detail', query: { id: this.info.stock_in_order } });
      },
      clickstockoutorder() {
        this.$router.push({ path: '/warehouse/outStock_detail', query: { id: this.info.stock_out_order } });
      },
      clickcollectionorder() {
        this.$router.push({ path: '/finance/collection_detail', query: { id: this.info.collection_order } });
      },
      clickvoidcollectionorder() {
        this.$router.push({ path: '/finance/collection_detail', query: { id: this.info.void_collection_order } });
      },
      clickchargeorder() {
        this.$router.push({ path: '/finance/income_and_pay', query: { search: this.info.charge_order_number } });
      },
      clickvoidchargeorder() {
        this.$router.push({ path: '/finance/income_and_pay', query: { search: this.info.void_charge_order_number } });
      },
    },
    mounted() {
      this.initData();
    },
  }
</script>
<style>
</style>
